// extracted by mini-css-extract-plugin
export default {"hidden":"VMatchNotifications_hidden_2RB5l","notification":"VMatchNotifications_notification_F7jMK","root":"VMatchNotifications_root_LNijT"};